import { I18n } from '@app/i18n/strings-keys';
import { ToolbarButtonDefinition } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/toolbar-button.type';

export const GROUP_BTN_REPLENISH_BASE: ToolbarButtonDefinition = {
  caption: I18n.Forms.TransferForm.BtnReplenish,
  class: 'btn-primary',
  value: 'replenish',
};

export const GROUP_BTN_BULK_REPLENISH_BASE: ToolbarButtonDefinition = {
  ...GROUP_BTN_REPLENISH_BASE,
  caption: I18n.Forms.TransferForm.BtnBulkReplenish,
};

export const BTN_REPLENISH_QOH: ToolbarButtonDefinition = {
  caption: I18n.Forms.TransferForm.BtnReplenishQOH,
  tooltip: I18n.Forms.TransferForm.ReplenishQOHTooltip,
};

export const BTN_REPLENISH_ZERO_QOH: ToolbarButtonDefinition = {
  caption: I18n.Forms.TransferForm.BtnReplenishZeroQOH,
  tooltip: I18n.Forms.TransferForm.ReplenishZeroQOHTooltip,
};

export const BTN_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY: ToolbarButtonDefinition =
  {
    caption: I18n.Forms.TransferForm.BtnReplenishEndingCountExpectedQty,
    tooltip: I18n.Forms.TransferForm.ReplenishEndingCountOrExpectedQTYTooltip,
  };

export const BTN_BULK_REPLENISH_QOH: ToolbarButtonDefinition = {
  caption: I18n.Forms.TransferForm.BtnBulkReplenishQOH,
  tooltip: I18n.Forms.TransferForm.ReplenishQOHTooltip,
};

export const BTN_BULK_REPLENISH_ZERO_QOH: ToolbarButtonDefinition = {
  caption: I18n.Forms.TransferForm.BtnBulkReplenishZeroQOH,
  tooltip: I18n.Forms.TransferForm.ReplenishZeroQOHTooltip,
};

export const BTN_BULK_REPLENISH_ENDING_COUNT_OR_EXPECTED_QTY: ToolbarButtonDefinition =
  {
    caption: I18n.Forms.TransferForm.BtnBulkReplenishEndingCountExpectedQty,
    tooltip: I18n.Forms.TransferForm.ReplenishEndingCountOrExpectedQTYTooltip,
  };
